/* eslint-disable react/prop-types */

import { forwardRef, useState, useEffect, useMemo } from 'react';
//@ts-expect-error no types for this file
import { ThreadViewStoreSingleton } from '../../ThreadViewStoreSingleton';
import ThreadViewManager from './ThreadViewManager';
//@ts-expect-error no types for this file
import { DeletedMessagesContext } from '../../thread-deletion/context/DeletedMessagesContext';
//@ts-expect-error no types for this file
import { AsyncComponentsContext } from '../context/AsyncComponentsContext';
//@ts-expect-error no types for this file
import { ForwardingContext } from '../../unified-thread-history/context/ForwardingContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ThreadViewWrapper = /*#__PURE__*/forwardRef(({
  AsyncUIAvatar,
  auth = {},
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  beaconTracker,
  //beacon tracker is deprecated, we should be just using the regluar tracker
  children,
  disableForwarding = false,
  inboxId,
  lifecycle = {
    onThreadTrackingContextChange: () => {}
  },
  omnibusData,
  showDeletedMessages = false,
  threadChannels,
  threadId,
  ticketCount,
  tracker,
  vid,
  visitor
}, ref) => {
  // initialize store singleton if it hasn't been
  ThreadViewStoreSingleton.init({
    auth,
    threadId,
    omnibusData
  });

  // delay mounting by one cycle to give the manager
  // a chance to sync state
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);
  const deletedMessagesContextValue = useMemo(() => ({
    showDeletedMessages
  }), [showDeletedMessages]);

  // while we support forwarding/reply with a pop-out communicator, we need this
  // escape hatch to hide forwarding/reply buttons in messages for the agent
  // thread view ui.
  const forwardingContextValue = useMemo(() => ({
    forwardingEnabled: !disableForwarding
  }), [disableForwarding]);
  const threadViewManagerProps = {
    showDeletedMessages,
    inboxId: inboxId || undefined,
    lifecycle,
    threadChannels: threadChannels || undefined,
    threadId,
    ticketCount: ticketCount || undefined,
    tracker,
    vid: vid || undefined,
    visitor: visitor || undefined
  };
  // Render the thread view manager to interact with the
  // inner store (if it's in use) without overwriting the
  // children's redux context. Until everything migrated,
  // we also need to run the same behavior on the app-hosted
  // store as well
  return /*#__PURE__*/_jsx(AsyncComponentsContext.Provider, {
    value: {
      AsyncUIAvatar
    },
    children: /*#__PURE__*/_jsx(ForwardingContext.Provider, {
      value: forwardingContextValue,
      children: /*#__PURE__*/_jsxs(DeletedMessagesContext.Provider, {
        value: deletedMessagesContextValue,
        children: [/*#__PURE__*/_jsx(ThreadViewManager, Object.assign({}, threadViewManagerProps, {
          ref: ref
        })), mounted ? children : null]
      })
    })
  });
});
ThreadViewWrapper.displayName = 'ThreadViewWrapper';
export default ThreadViewWrapper;